import { fbt } from 'fbtee'
import { ImageCropDialog, type ImageCropDialogProps } from './ImageCropDialog'

const OUTPUT_SIZE = 400

export function AvatarCropDialog(props: ImageCropDialogProps) {
  return (
    <ImageCropDialog
      {...props}
      title={
        <fbt desc="Dialog title for the avatar crop step before upload">
          Adjust your photo
        </fbt>
      }
      zoomLabel={<fbt desc="Label next to the zoom slider in the avatar crop dialog">Zoom</fbt>}
      zoomAriaLabel={fbt(
        'Zoom',
        'Aria label for the zoom slider in the avatar crop dialog',
      ).toString()}
      aspect={1}
      cropShape="round"
      output={{ width: OUTPUT_SIZE, height: OUTPUT_SIZE }}
      quality={0.9}
    />
  )
}
